import { render, staticRenderFns } from "./TournamentSettingsMenu.vue?vue&type=template&id=6dfc553f&scoped=true"
import script from "./TournamentSettingsMenu.vue?vue&type=script&lang=js"
export * from "./TournamentSettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./TournamentSettingsMenu.vue?vue&type=style&index=0&id=6dfc553f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc553f",
  null
  
)

export default component.exports